<template lang="pug">
.streams-settings
  .d-f.m-b-2
    Button(@click="addNewStream()", style="white-space: nowrap", :class="`${!addStream ? 'very-blue' : 'very-blue-light'}`") {{ $t('settings.create_new_stream') }}
    .ml-a
    .icon-buttons-group.m-r-2.m-l-2
      IconButton(icon="menu-left" :class="`${pagination.page > 1 ? 'blue' : 'gray'}`", :large-icon="true", @clicked="pagination.page > 1 ? paginate(-1) : null")
      IconButton(icon="menu-right" :class="`${pagination.page < pagination.maxPage ? 'blue' : 'gray'}`", :large-icon="true", @clicked="pagination.page < pagination.maxPage ? paginate(1) : null")
  CardMinimal
    //(:tooltip="$t('settings.streams_list_description')", tooltipClass="bottom-right")
    .p-a-4.searchArea
      FormInput(type="text", :placeholder="$t('common.search')", v-model="searchString", id="user-email", :outline="true").ml-a.mr-a
    .streams(v-if="streams.length > 0")
      ExpandableListItem(v-for="stream in streams", :key="stream.id", :selected="selectedStream === stream.id")
        .p-a-4(@click="selectStream(stream.id)")
          p {{ stream.metadata.title }}
          .description(v-if="stream.metadata.description") {{ stream.metadata.description }}
        template(slot="dots")
          ul
            li.red(@click="removeStream(stream.id)")
              i.mdi.mdi-trash-can-outline
              | {{ $t('products.remove') }}
        template(slot="expand")
          .d-f.f-g.fd-c.fd-md-r.f-w
            div.f-1
              label {{ $t('broadcast.stream_address') }}
              .metadata-row
                FormInput.streamIngestionURL(readonly="readonly", :id="`${stream.id}-ingestion-address`", :copy="true", :value="`${stream.cdn.ingestion_type}://${stream.cdn.ingestion_address}`")
              label.m-t-2 {{ $t('broadcast.stream_name') }}
              .metadata-row
                FormInput.streamName(readonly="readonly", :id="`${stream.id}-stream-name`", :copy="true", :value="stream.cdn.stream_name")
            div.f-1
              label Region
              .metadata-row
                FormInput.streamRegion(readonly="readonly", :id="`${stream.id}-stream-region`", :copy="true", :value="stream.cdn.region")
    .p-a-4.no-streams(v-else)
      template(v-if="searchString")
        p {{ $t('settings.no_streams_matches_search') }}
      template(v-else)
        p {{ $t('settings.no_streams_part_1') }}
        p {{ $t('settings.no_streams_part_2') }}
  portal(to="modals")
    Modal(:show="addStream", :stuck="createState !== ''" @close="cancelCreateStream()" title="Create new stream").auto-height
      .p-a-4
        p.m-b-1 {{ $t('settings.stream_title').toUpperCase() }}
        FormInput(type="text", v-model="newStream.metadata.title", id="stream-title", :outline="true").m-b-2
        p.m-b-1 {{ $t('settings.stream_description').toUpperCase() }}
        FormInput(type="text", v-model="newStream.metadata.description", id="stream-description", :outline="true").m-b-2
        p.m-b-1 {{ $t('settings.ingestion_region').toUpperCase() }}
        FormDropdown(:items="regions", :value="newStream.cdn.region", @input="newStream.cdn.region = $event.value").medium
      template(v-slot:footer)
        .d-f.f-w
          Button.m-r-4(@click="newStreamValid ? createStream() : null", style="white-space: nowrap", :icon="createState === 'creating' ? 'loading mdi-spin' : null", :disabled="!newStreamValid", :class="`${newStreamValid ? 'very-blue' : 'very-blue-light'} ${createState === 'created' ? 'success' : ''}`").very-blue
            template(v-if="createState === ''") {{ $t('settings.create_new_stream') }}
            template(v-else-if="createState === 'creating'") {{ $t('settings.creating_new_stream') }}
            template(v-else-if="createState === 'created'") {{ $t('settings.new_stream_created') }}
          Button.ml-a.outline(@click="cancelCreateStream()") {{ $t('common.cancel') }}
</template>

<script>

import ExpandableListItem from '@/components/Lists/ExpandableListItem.vue';

export default {
  components: {
    ExpandableListItem,
  },
  computed: {
    /**
     * Return a list of streams
     * @returns {Array}
     */
    streams() {
      const { pagination: { page, perPage }, searchString } = this;
      const streams = this.$store.getters['Streams/streams'];
      const start = (page - 1) * perPage;
      const list = searchString ? streams.filter(stream => searchString.toLowerCase().split(' ').every(word => stream.metadata.title.toLowerCase().indexOf(word) > -1)) : streams;
      // eslint-disable-next-line
      this.pagination.maxPage = ((list.length / perPage) % 1 === 0) ? (list.length / perPage) : Math.floor(list.length / perPage) + 1;
      return list.slice(start, start + perPage);
    },
    /**
     * Return a list of regions available
     @returns {Array}
     */
    regions() {
      const { region } = this.newStream.cdn;
      return [
        { value: 'europe-west', string: 'Europe (West)', selected: region === 'europe-west' },
        { value: 'europe-north', string: 'Europe (North)', selected: region === 'europe-north' },
        { value: 'australia-southeast', string: 'Australia (Southeast)', selected: region === 'australia-southeast' },
      ];
    },
    /**
     * Returns a boolean if the newStream form is valid
     * @return {Boolean}
     */
    newStreamValid() {
      return this.newStream.metadata.title !== '' && this.newStream.cdn.region !== '';
    },
  },
  methods: {
    /**
     * Get streams
     */
    getStreams() {
      return this.$store.dispatch('Streams/getStreams');
    },
    /**
     * Select a stream
     * @param {String} id
     */
    selectStream(id) {
      const { selectedStream } = this;
      this.selectedStream = selectedStream === id ? null : id;
      this.addStream = false;
    },
    /**
     * Pre add new stream
     */
    addNewStream() {
      this.selectedStream = null;
      this.addStream = true;
    },
    /**
     * Cancel streamcreation. Reset stuff
     */
    cancelCreateStream() {
      this.newStream = { ...this.newStream, ...{ cdn: { region: 'europe-west' }, metadata: { title: '', description: '' } } };
      this.addStream = false;
    },
    /**
     * Remove stream
     * @param {String} id
     */
    removeStream(id) {
      // eslint-disable-next-line
      swal({ title: this.$t('errors.are_you_sure'), text: this.$t('settings.once_removed'), icon: 'warning', buttons: true, dangerMode: true }).then(async (remove) => {
        if (remove) {
          await this.$store.dispatch('Streams/removeStream', id);
          this.selectedStream = null;
        }
      });
    },
    /**
     * Create a new stream
     */
    async createStream() {
      if (!this.newStreamValid) return;
      this.createState = 'creating';
      const created = await this.$store.dispatch('Streams/createStream', this.newStream);

      if (!created) {
        this.createState = '';
        swal({ title: this.$t('errors.error_occured'), text: this.$t('settings.cant_create_stream'), icon: 'error' });
        return;
      }

      this.createState = 'created';
      setTimeout(() => {
        this.createState = '';
        this.cancelCreateStream();
      }, 1000);
    },
    /**
     * Paginate
     * @param {Number} num
     */
    paginate(num) {
      this.pagination.page += num;
    },
  },
  data() {
    return {
      pagination: {
        page: 1,
        perPage: 10,
        maxPage: 1,
      },
      searchString: '',
      selectedStream: null,
      addStream: false,
      createState: '',
      newStream: {
        cdn: {
          region: 'europe-west',
        },
        metadata: {
          title: '',
          description: '',
        },
      },
    };
  },
  mounted() {
    this.getStreams();
  },
};
</script>

<style lang="scss" scoped>
.searchArea {
  background-color: white;
  border-radius: 10px 10px 0 0;
  border-bottom: 1px solid #E7E9EC;
}

.no-streams {
  text-align: center
}

.description {
  color: lighten(black, 30%);
  margin-top: 2px;
}
</style>
